import { render, staticRenderFns } from "./payOrdersALY.vue?vue&type=template&id=2c4449e2&scoped=true"
import script from "./payOrdersALY.vue?vue&type=script&lang=js"
export * from "./payOrdersALY.vue?vue&type=script&lang=js"
import style0 from "./payOrdersALY.vue?vue&type=style&index=0&id=2c4449e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4449e2",
  null
  
)

export default component.exports